import * as ast from '../../generated/ast.js';
import { checkForDuplicateAndRequiredProperties } from '../../common/utilities.js';
export function validateButtonsJson(buttonsJson, accept) {
    // Get the parent Node to which this belongs. The full path to that is
    // ButtonsJson => RichAssetButtons => RichAsset => Node
    const parentNode = buttonsJson.$container?.$container?.$container;
    // Check for duplicate and required properties
    checkForDuplicateAndRequiredProperties({
        node: buttonsJson,
        allProperties: buttonsJson.properties,
        requiredProperties: [
            ast.TypeStaticProperty,
            ast.ButtonOptionsArrayProperty,
        ],
        parentNode,
        accept,
    });
}
export function validateButtonOption(buttonOption, accept) {
    // Get the parent ast.Node to which this belongs. The full path to that is
    // ast.ButtonOption => ast.ast.ButtonOptionsArray => ast.ButtonsJson => RichAssetButtons => RichAsset => ast.Node
    const parentNode = buttonOption.$container?.$container?.$container?.$container
        ?.$container;
    // Check for duplicate and required properties
    checkForDuplicateAndRequiredProperties({
        node: buttonOption,
        allProperties: buttonOption.properties,
        requiredProperties: [ast.LabelProperty],
        parentNode,
        accept,
    });
}
export function validateVariableObject(variableObject, accept) {
    // Get the parent ast.Node to which this belongs. The full path to that is
    // VariableObject => VariablesArrayProperty => ButtonOption => ButtonOptionsArray => ButtonsJson => RichAssetButtons => RichAsset => Node
    const parentNode = variableObject.$container?.$container?.$container
        ?.$container?.$container?.$container?.$container;
    // Check for duplicate and required properties
    checkForDuplicateAndRequiredProperties({
        node: variableObject,
        allProperties: variableObject.properties,
        requiredProperties: [ast.VariableProperty, ast.ValueProperty],
        parentNode,
        accept,
    });
}
//# sourceMappingURL=buttons.js.map